import React, { useEffect, useState } from "react";
import { StyleSettings } from "../../styles/StyleSettings";

interface SnLabelProps {
  text: string;
  type: string;
  color?: string;
  size?: number;
}

export function SnLabel({ text, type, color, size }: SnLabelProps) {
  const [width, setWidth] = useState({
    minWidth: "120px",
    maxWidth: "120px",
  });
  const fontSize = StyleSettings.font;

  useEffect(() => {
    switch (type) {
      case "SearchPanel":
        setWidth({ minWidth: "120px", maxWidth: "120px" });
        break;
      case "SharedForm":
        setWidth({ minWidth: "130px", maxWidth: "130px" });
        break;
      case "FreeForm":
        setWidth({ minWidth: "95px", maxWidth: "80px" });
        break;
      case "AfterLabel":
        setWidth({ minWidth: "", maxWidth: "" });
        break;
    }

    if (size) {
      setWidth({
        minWidth: `${size}px`,
        maxWidth: `${size}px`,
      });
    }
  }, [type, size]);

  return (
    <div
      className="flex items-center h-full"
      style={{
        ...width,
        fontSize: fontSize,
        color: color ? color : "black",
        fontWeight: color ? (color == "black" ? "normal" : "bold") : "normal",
      }}
    >
      {text}
    </div>
  );
}

export default React.memo(SnLabel);
